import { render, staticRenderFns } from "./junit-gantt-chart.vue?vue&type=template&id=5314b7a8&scoped=true&"
import script from "./junit-gantt-chart.vue?vue&type=script&lang=js&"
export * from "./junit-gantt-chart.vue?vue&type=script&lang=js&"
import style0 from "./junit-gantt-chart.vue?vue&type=style&index=0&id=5314b7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314b7a8",
  null
  
)

export default component.exports